// extracted by mini-css-extract-plugin
module.exports = {"selectGroup":"SendSurveyModal_selectGroup__39JkO","active":"SendSurveyModal_active__2uJ4Y","inactive":"SendSurveyModal_inactive__3E2g1"};